import React, { useState, useEffect } from 'react';
import { useStatus } from '../context/StatusContext';
import '../styles/Footer.css';
import { getApiBase } from '../utils/apiBase';

const Footer = () => {
  const [timestamps, setTimestamps] = useState({});
  const { pageStatuses } = useStatus();

  useEffect(() => {
    const fetchTimestamps = async () => {
      try {
        const API = getApiBase();
        const response = await fetch(`${API}/export_timestamps.json`);
        const data = await response.json();
        
        // Process timestamps for each page
        const pageTimestamps = {
          'FTSO Subs': {
            timestamp: Math.min(
              new Date(data['submission_summary.json']?.last_updated || Date.now()),
              new Date(data['pivot_voting_round.json']?.last_updated || Date.now())
            ),
            status: pageStatuses.ftsoSubmissions
          },
          'FDC Subs': {
            timestamp: Math.min(
              new Date(data['fdc_submission_summary.json']?.last_updated || Date.now()),
              new Date(data['fdc_data.json']?.last_updated || Date.now())
            ),
            status: pageStatuses.fdcSubmissions
          },
          'Nodes': {
            timestamp: new Date(data['node_health.json']?.last_updated || Date.now()),
            status: pageStatuses.nodes
          },
          'Validators': {
            timestamp: new Date(data['validator_info.json']?.last_updated || Date.now()),
            status: pageStatuses.validators
          },
          'Indexers': {
            timestamp: new Date(data['indexer_states.json']?.last_updated || Date.now()),
            status: pageStatuses.indexers
          },
          'Fast Updates': {
            timestamp: new Date(data['fast_updates.json']?.last_updated || Date.now()),
            status: pageStatuses.fastUpdates
          },
          'REGISTRATION': {
            timestamp: new Date(data['voter_registration.json']?.last_updated || Date.now()),
            status: pageStatuses.registration
          },
          'Balances': {
            timestamp: new Date(data['address_balances.json']?.last_updated || Date.now()),
            status: pageStatuses.balances
          }
        };

        // Only update if something actually changed to avoid reflows/flicker
        setTimestamps(prev => {
          try {
            return JSON.stringify(prev) === JSON.stringify(pageTimestamps) ? prev : pageTimestamps;
          } catch {
            return pageTimestamps;
          }
        });
      } catch (error) {
        console.error('Error fetching timestamps:', error);
      }
    };

    fetchTimestamps();
    const interval = setInterval(fetchTimestamps, 20000);
    // On focus/visibility, refresh immediately for snappy footer
    const refresh = () => fetchTimestamps().catch(() => {});
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
    });
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [pageStatuses]);

  const formatTimestamp = (timestamp) => {
    return new Date(timestamp).toLocaleString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZone: 'UTC'
    });
  };

  const getStatusClass = (status) => {
    const s = (status || 'grey').toLowerCase();
    const normalized = s === 'yellow' ? 'amber' : s;
    return `status-dot bg-${(normalized || 'grey')}`;
  };

  return (
    <footer className="footer">
      <div className="timestamp-grid">
        {Object.entries(timestamps).map(([page, data]) => (
          <div key={page} className={`timestamp-item bg-${((data && data.status) ? String(data.status).toLowerCase().replace('yellow','amber') : 'grey')}`}>
            <span className="header-label">{page}</span>
            <span className="header-value">
              ({formatTimestamp(data.timestamp)})
            </span>
          </div>
        ))}
      </div>
    </footer>
  );
};

export default Footer;